module.exports = __webpack_public_path__ + "webpc/img/icon_assets_3.30bd3015.png";